import { render, staticRenderFns } from "./LoadingItems.vue?vue&type=template&id=2608ea7a&scoped=true&"
import script from "./LoadingItems.vue?vue&type=script&lang=js&"
export * from "./LoadingItems.vue?vue&type=script&lang=js&"
import style0 from "./LoadingItems.vue?vue&type=style&index=0&id=2608ea7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608ea7a",
  null
  
)

export default component.exports